import React, { useState } from 'react'

import { Notification, toast } from 'components/ui'
import {
    setChangePackageTo,
    setPlanPanelExpand,
} from 'store/checkout/selectPlanSlice'
import { useDispatch, useSelector } from 'react-redux'
import { apiVerifyTransactionWireTransfer } from 'services/BillingService'
import { clearCheckout } from 'store/checkout/titlesSlice'
import { clearFiltersList } from 'store/search/filtersSlice'
import FormFooter from '../FormFooter'
import { setSubscription } from 'store/base/commonSlice'

const WireTransferCheckoutForm = ({
    subTotalAmount,
    totalAmount,
    startingDate,
    selectedPackage,
    termsOfUseContent,
}) => {
    const { selectedTitles, premiumTitlesCount, standardTitlesCount } =
        useSelector((state) => state.checkout.titles)

    const dispatch = useDispatch()

    const [isSubmitting, setIsSubmitting] = useState(false)
    const { changePackageTo } = useSelector(
        (state) => state.checkout.selectPlan
    )
    const handleSubmit = async (event) => {
        // We don't want to let default form submission happen here,
        // which would refresh the page.
        event.preventDefault()

        setIsSubmitting(true)

        const response = await apiVerifyTransactionWireTransfer({
            selectedPackage: selectedPackage.id,
            selectedTitles: selectedTitles.map((title) => title.id),
            premiumTitlesCount,
            standardTitlesCount,
            upgrade: changePackageTo?.id ? true : false,
        })

        if (response.data.status === 'success') {
            await dispatch(clearCheckout())
            await dispatch(setPlanPanelExpand(false))
            await dispatch(clearFiltersList())
            await dispatch(setSubscription(response.data.subscription))
            await dispatch(setChangePackageTo(null))
            const toastNotification = (
                <Notification
                    title="Your Request Sent Successfully"
                    type="success"
                    closable
                    duration={10000}
                >
                    <div>Thank you, our team will review your request.</div>
                    <br />
                    <div>
                        In the meantime, you will receive emails containing our
                        bank details.
                    </div>
                </Notification>
            )
            toast.push(toastNotification)
        } else {
            toast.push(
                <Notification
                    title="Sorry, Something Went Wrong"
                    type="danger"
                    closable
                    duration={10000}
                >
                    <div className="text-red-400 font-medium">
                        {response.data.message}
                    </div>
                </Notification>
            )
        }

        // Your customer will be redirected to your `return_url`. For some payment
        // methods like iDEAL, your customer will be redirected to an intermediate
        // site first to authorize the payment, then redirected to the `return_url`.

        setIsSubmitting(false)
    }

    return (
        <form onSubmit={handleSubmit}>
            <div className="flex flex-col gap-10 pb-10">
                <div>
                    <h5 className="mb-3">WireTransfer</h5>
                    <div>
                        <p>
                            To pay via bank-to-bank wire transfer, please wire
                            the funds to the below account,{' '}
                            <b>quoting or referencing the invoice numbers</b>{' '}
                            you are paying:
                        </p>
                    </div>
                    <div className="my-4">
                        <p>Bank Name: CITI BANK</p>
                        <p>Account No: 4986196895</p>
                        <p>Account Name: SyndiGate Media Inc.</p>
                        <p>Account Currency: US dollar ($)</p>
                        <p>Swift: CITIUS33</p>
                        <p>Routing No: 021000089</p>
                        <p>Address: 666 5th Avenue, New York, NY 10103, USA</p>
                    </div>
                </div>
                <FormFooter
                    subTotalAmount={subTotalAmount}
                    totalAmount={totalAmount}
                    isSubmitting={isSubmitting}
                    startingDate={startingDate}
                    termsOfUseContent={termsOfUseContent}
                />
            </div>
        </form>
    )
}

export default WireTransferCheckoutForm
